export default {
  init: () => {
    const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    if ( vw < 1024 ) {
      new Swiper ('.leaders-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 32,
      });
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/modules/leaders_swiper.js